module.exports = __webpack_public_path__ + "static/media/default.d7ab8777.svg";